export const BLOG_THUMBNAIL_WIDTH = 1920;
export const BLOG_THUMBNAIL_HEIGHT = 1080;
export const BLOG_THUMBNAIL_ASPECT_RATIO = BLOG_THUMBNAIL_HEIGHT / BLOG_THUMBNAIL_WIDTH;

// Note: Pretty sure artists intended the video to be 16:9 aspect ratio. However, all existing thumbnail assets 
//       are in the aspect ratio specified above, so we'll work with what we have.
export const PROJECT_THUMBNAIL_ASPECT_RATIO = 674 / 1200;

export const SHOWREEL_VIDEO_ASPECT_RATIO = 1080 / 1920;
